/***
 * Copyright (c) Myia 2023-2025 - All Rights Reserved
 */

/* eslint-disable max-len */

import { HTMLAttributes } from 'react';
import { NavLink, NavLinkProps } from 'react-router';

import { cn } from '@/lib/utils';

interface MainNavProps extends HTMLAttributes<HTMLElement> {
    currentProjectSlug: string;
    suiteSlug?: string;
}

const Link = ({ className, end = false, ...props }: NavLinkProps & { end?: boolean }) => {
    return (
        <NavLink
            className={({ isActive }) =>
                cn(
                    'text-sm font-normal transition-colors hover:text-primary',
                    !isActive && 'text-muted-foreground border-b-2 border-transparent',
                    isActive && 'border-b-2 border-b-black ',
                    className,
                )
            }
            end={end} // Set the end prop to enforce exact matching
            {...props}
        />
    );
};

const MainNav = ({ className, currentProjectSlug, suiteSlug, ...props }: MainNavProps) => {
    return (
        <nav className={cn('flex items-center space-x-4 lg:space-x-6', className)} {...props}>
            {currentProjectSlug && suiteSlug === undefined && (
                <>
                    <Link to={`/project/${currentProjectSlug}`} end={true}>
                        Suites
                    </Link>
                    <Link to={`/project/${currentProjectSlug}/settings`}>Settings</Link>
                </>
            )}
            {currentProjectSlug && suiteSlug && (
                <>
                    <Link to={`/suite/${currentProjectSlug}/${suiteSlug}/executions`}>Runs</Link>
                    <Link to={`/suite/${currentProjectSlug}/${suiteSlug}/stories`}>Stories</Link>
                    <Link to={`/suite/${currentProjectSlug}/${suiteSlug}/blocks`}>Blocks</Link>
                    <Link to={`/suite/${currentProjectSlug}/${suiteSlug}/settings`}>Settings</Link>
                </>
            )}
        </nav>
    );
};

export default MainNav;
